module.exports = __webpack_public_path__ + "static/media/ob-insurance.d4ba2596.svg";